export const routesUser = [
  {
    path: "/profil",
    name: "profil",
    component: () => import("@/views/user/profil/index.vue"),
    meta: { public: false, title: "Profil" },
  },
  {
    path: "/bakiyem",
    name: "bakiyem",
    component: () => import("@/views/bakiyem/index.vue"),
    meta: { public: false, title: "Bakiyem" },
  },
  {
    path: "/kullanicilar",
    name: "kullanicilar",
    component: () => import("@/views/kullanicilar/index.vue"),
    meta: {
      public: false,
      title: "Kullanıcılar",
      yetki: { k: [1000002] },
    },
  },
  {
    path: "/kullanicilar/:userId",
    name: "kullanicilar_profil",
    component: () => import("@/views/kullanicilar/profil/index.vue"),
    meta: {
      public: false,
      title: "Kullanıcı Profil",
      yetki: { k: [1000002] },
    },
  },
  {
    path: "/groupyetki",
    name: "groupyetki",
    component: () => import("@/views/kullanicilar/groupyetki/index.vue"),
    meta: {
      public: false,
      yetki: { k: [1000102] },
      title: "Group Yetki",
    },
  },
];
